/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-banner.has-scroll-animation' ).each( function( key, val ) {
        const docStyle = getComputedStyle( document.documentElement );
        const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
        const navBottomHeight = docStyle.getPropertyValue( '--navbarBottomHeight' );
        const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
        const nextComponent = $( this ).next();
        let loggedOutOffset = 14;
        if ( docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ) {
          loggedOutOffset += parseInt( adminbarHeight );
        }

        if ( this == $( 'main > *' ).first()[0] ) {
          $( nextComponent ).css( {
            'margin-top': ( $( this ).height() * -1 ) - loggedOutOffset,
          } );
        } else {
          $( nextComponent ).css( {
            'margin-top': ( $( this ).height() * -1 ) + parseInt( navBottomHeight ),
          } );
        }

        $( val ).find( '.scroll-down' ).on( 'click', function() {
          const _this = this;
          const docStyle = getComputedStyle( document.documentElement );
          const navHeight = docStyle.getPropertyValue( '--navbarHeight' );

          if ( $( nextComponent ).length ) {
            $( 'html, body' ).animate( {
              scrollTop: ( $( val ).offset().top + $( val ).height() ) - parseInt( navHeight ),
            }, 1000 );
          }
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: nextComponent,
            start: 'top ' + topOffset,
            end: 'bottom top',
            scrub: 0,
          },
        } );

        tl.to( this, {y: '-100%', ease: 'linear'}, 0 );
        ScrollTrigger.refresh();
      } );

      $( '.hero-banner' ).each( function( key, val ) {
        const docStyle = getComputedStyle( document.documentElement );
        const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
        const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
        const nextComponent = $( this ).next();

        $( val ).find( '.scroll-down' ).on( 'click', function() {
          if ( $( nextComponent ).length ) {
            $( 'html, body' ).animate( {
              scrollTop: ( $( val ).offset().top + $( val ).height() ) - parseInt( topOffset ),
            }, 1000 );
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
